import { render, staticRenderFns } from "./ContabilitaDocumentoRigheEditComponent.vue?vue&type=template&id=e3f32032&scoped=true"
import script from "./ContabilitaDocumentoRigheEditComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoRigheEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoRigheEditComponent.vue?vue&type=style&index=0&id=e3f32032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f32032",
  null
  
)

export default component.exports